export enum UserPreferenceKeysEnums {
  RosterSorting = 'rosterSorting',
  RosterEmployeeNameDisplay = 'rosterEmployeeNameDisplay',
  RosterEmployeeGridSourceCostCenter = 'rosterEmployeeGridSourceCostCenter',
  RosterEmployeeGridDestinationCostCenter = 'rosterEmployeeGridDestinationCostCenter'
}

export enum UserPreferenceValueEnums {
  Show = 'show',
  Hide = 'hide'
}

/**
 * Verbatim from the Dojo screen this replaces — `frontend/aysist/constants/RosterMode.js` and
 * `RosterWidget/DisplayType.ts`. The values match one for one so #2499 can switch modes without a
 * mapping layer.
 *
 * Note the legacy file misspells the open-requests *key* as `OPEN_REQUSTS`; only its value
 * (`OPEN_REQUESTS`) is what crosses over.
 */
export enum RosterPlanModeEnum {
  View = 'VIEW',
  Plan = 'PLAN',
  ChangesAfterPublication = 'CHANGES_AFTER_PUBLICATION',
  OpenRequests = 'OPEN_REQUESTS',
  DutyView = 'DUTY_VIEW'
}

export enum RosterDisplayTypeEnum {
  MonthView = 'MONTH_VIEW',
  DayView = 'DAY_VIEW'
}
